export default __webpack_public_path__ + "static/media/with-ysanne.ce8fb3a4.jpg";